export type ChannelSnapshot = {
    id: string;
    name: string;
    position: number;
    parentId: string | null;
};

export type ChannelPositionDiff = {
    channelId: string;
    channelName: string;
    oldPosition: number;
    newPosition: number;
    oldParentId: string | null;
    newParentId: string | null;
    type: "move" | "category_change";
};

export type ChannelPositionDiffMap = Map<string, ChannelPositionDiff>;

export function computeChannelPositionDiff(
    before: Map<string, ChannelSnapshot>,
    after: Map<string, ChannelSnapshot>
): ChannelPositionDiffMap {
    const diffs: ChannelPositionDiffMap = new Map();

    for (const [id, afterChannel] of after) {
        const beforeChannel = before.get(id);
        if (!beforeChannel) continue;

        if (
            beforeChannel.position !== afterChannel.position ||
            beforeChannel.parentId !== afterChannel.parentId
        ) {
            diffs.set(id, {
                channelId: id,
                channelName: afterChannel.name,
                oldPosition: beforeChannel.position,
                newPosition: afterChannel.position,
                oldParentId: beforeChannel.parentId,
                newParentId: afterChannel.parentId,
                type:
                    beforeChannel.parentId !== afterChannel.parentId
                        ? "category_change"
                        : "move",
            });
        }
    }

    return diffs;
}
